import React from 'react';
import { Box, Alert, Accordion, AccordionSummary, AccordionDetails, Typography, Divider } from '@mui/material';
import { MdExpandMore, MdErrorOutline } from 'react-icons/md';

const ShipyardNotification = ({
    type = 'error',
    variant = 'standard',
    text = 'Error on page, please review.',
    titleText = '',
    collapsible = false,
    ...restOfProps
}) => {
    return (
        <Box
            sx={{
                marginLeft: (theme) => theme.spacing(5),
                marginRight: (theme) => theme.spacing(5),
            }}
        >
            {collapsible ? (
                <Accordion
                    sx={{
                        backgroundColor: '#FBF1F1',
                        color: (theme) => theme.palette.error.main,
                        fontWeight: 700,
                    }}
                    {...restOfProps}
                >
                    <AccordionSummary
                        expandIcon={
                            <Box
                                component={MdExpandMore}
                                sx={{ fill: (theme) => theme.palette.error.main, fontSize: 30 }}
                            />
                        }
                    >
                        <Box
                            component={MdErrorOutline}
                            sx={{ padding: (theme) => theme.spacing(0.25), marginRight: (theme) => theme.spacing(0.5), fontSize: 30 }}
                        />
                        <Box
                            component="span"
                            sx={{ marginTop: (theme) => theme.spacing(0.75), fontSize: 14 }}
                        >
                            {titleText}
                        </Box>
                    </AccordionSummary>

                    <Divider />

                    <AccordionDetails>
                        <Typography
                            sx={{
                                marginTop: (theme) => theme.spacing(2),
                                marginLeft: (theme) => theme.spacing(4),
                                fontSize: 14,
                            }}
                        >
                            {text}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ) : (
                <Alert
                    severity={type}
                    variant={variant}
                    sx={{
                        color: (theme) => theme.palette.error.main,
                        fontWeight: 700,
                        borderRadius: 3,
                    }}
                    {...restOfProps}
                >
                    {text}
                </Alert>
            )}
        </Box>
    );
};

export default ShipyardNotification;
